import { ModuleWithProviders, NgModule } from '@angular/core';

import { InterceptorsModule } from './interceptor/interceptors.module';
import { DIALOG_MESSAGE } from './model/dialog-message.model';
import {
    API_STORAGE, APP_UPDATE, IPacificwiseAngularConfig
} from './model/pacificwise-angular-config.model';
import { ApiConfigService } from './service/api-config.service';
import { AuthenticationService } from './service/authentication.service';
import { BreakpointService } from './service/breakpoint.service';
import { DialogMessage } from './service/dialog-message.service';
import { EmptyDialogMessage } from './service/empty-dialog-message.service';
import { HotkeysService } from './service/hotkeys.service';
import { HttpCachingService } from './service/http-caching.service';
import { UserCredentialService } from './service/user-credential.service';
import { PacificwiseAngularSharedModule } from './shared/pacificwise-angular-shared.module';

@NgModule({
  declarations: [],
  providers: [
    DialogMessage,
    ApiConfigService,
    AuthenticationService,
    UserCredentialService,
    HttpCachingService,
    BreakpointService,
    HotkeysService,
    { provide: DIALOG_MESSAGE, useClass: EmptyDialogMessage },
  ],
  imports: [
    PacificwiseAngularSharedModule,
    InterceptorsModule
  ],
  exports: [InterceptorsModule]
})
export class PacificwiseAngularModule {
  static forRoot(config: IPacificwiseAngularConfig): ModuleWithProviders<PacificwiseAngularModule> {
    return {
      ngModule: PacificwiseAngularModule,
      providers: [
        {
          provide: API_STORAGE,
          useFactory: config.storage
        },
        {
          provide: APP_UPDATE,
          useValue: config
        }
      ]
    };
  }
}
